import { getRoundLabel } from '../util/preference-utils';
import { pluralizeWord } from '../util/stringUtils';

export enum ROUTES {
  ADMIN_PANEL = 'admin-panel',
  ADMIN_PANEL_AUDITOR_CONFIG = 'auditor-config',
  ADMIN_PANEL_COLUMNS = 'columns',
  ADMIN_PANEL_DATA_COLLECTION = 'data-collection-config',
  ADMIN_PANEL_DATA_DISPLAY = 'data-display',
  ADMIN_PANEL_FIELD_MANAGER = 'field-manager',
  ADMIN_PANEL_FIELDS = 'fields',
  ADMIN_PANEL_FORMATTERS = 'formatters',
  ADMIN_PANEL_MANAGE_ACCESS = 'manage-access',
  ADMIN_PANEL_MANAGE_ACCESS_COMPANY = 'company',
  ADMIN_PANEL_MANAGE_ACCESS_COLUMN_GRID_DISPLAY = 'column-grid-display',
  ADMIN_PANEL_MAPPINGS = 'company-mappings',
  ADMIN_PANEL_ORG_PROFILE = 'org-profile',
  ADMIN_PANEL_ROUND_CREATION = 'round-creation-settings',
  ADMIN_PANEL_RUBRICS = 'rubrics',
  ADMIN_PANEL_TEARSHEET_GENERATION = 'tearsheet-generation',
  ADMIN_PANEL_TABLE_DOWNLOAD = 'table-download',
  APPLICATION_SETTINGS = 'application-settings',
  ASSIGNED_COMPANIES = 'assigned',
  BULK_UPLOAD_REPORT = 'bulk-upload-report',
  CHATBOT = 'mobile',
  COMPANIES = 'companies',
  COMPANIES_OVERVIEW = 'companies-overview',
  COMPANY_PROFILES = 'company-profiles',
  COMPANY_PROFILE_CAP_TABLE = 'cap-table',
  CAP_TABLE_FORM = 'form',
  COMPANY_LIST = 'company-list',
  COMPANY_LIST_OVERVIEW = 'company-list-overview',
  COMPANY_SUMMARY_KPI_CHARTS = 'company-summary-kpi-charts',
  COMPANY_SUMMARY_FINANCIAL_SETTINGS = 'company-summary-financial-settings',
  COMPANY_SUMMARY_PERFORMANCE_SETTINGS = 'company-summary-performance-settings',
  COMPANY_PROFILE_COMPETITORS = 'competitors',
  COMPANY_PROFILE_MAPPINGS = 'mappings',
  COMPANY_PROFILE_NICHE_VCS = 'niche-vcs',
  COMPANY_PROFILE_PEOPLE = 'people',
  COMPANY_PROFILE_PERFORMANCE = 'performance',
  COMPANY_PROFILE_SCENARIOS = 'scenarios',
  COMPANY_PROFILE_SINGLE_SCENARIO = 'modelling',
  COMPANY_PROFILE_SCENARIO_SETTINGS = 'sc-settings',
  COMPANY_PROFILE_SCENARIO_RUN = 'sc-run',
  COMPANY_PROFILE_SCENARIO_WEIGHTED = 'sc-weighted',
  COMPANY_PROFILE_SUMMARY = 'summary',
  COMPANY_PROFILE_FINANCIALS = 'financials',
  CONFIG = 'config',
  CONFIG_DEAL_TYPES = 'deal-types',
  CONFIG_DEAL_STAGES = 'deal-stages',
  CONFIG_PASS_REASONS = 'pass-reasons',
  CONFIG_MISS_REASONS = 'miss-reasons',
  CONFIG_FIELD_AUTOMATION = 'field-automation',
  CONFIG_FUNDS = 'funds',
  CONFIG_SECTORS = 'sectors',
  CONFIG_KPI = 'all-kpis',
  CONFIG_KPI_GROUPS = 'kpi-groups',
  CONFIG_KPI_SOURCES = 'kpi-sources',
  DEAL_ANALYTICS = 'analytics',
  DEAL_ANALYTICS_KPI = 'deal-kpis',
  DEAL_ANALYTICS_DURATION_DETAILS = 'deal-duration',
  DEAL_FLOW = 'deal-flow',
  DEALS = 'deals',
  DETAILS_CONFIG = 'details-config',
  ENTITIES = 'entities',
  ENTITIES_STRUCTURE_CHART = 'structure-chart',
  ENTITIES_REGISTRY = 'registry',
  ENTITIES_DO_SLATE = 'do-slate',
  ENTITIES_BENEFICIAL_OWNERSHIP = 'beneficial-ownership',
  ENTITIES_REVIEW_QUEUES = 'review-queues',
  EXCEL_LOGIN = 'excel-login',
  FINANCE = 'finance',
  FINANCE2 = 'fin2.0',
  FINANCE2_OVERVIEW = 'main',
  FINANCE_ALL_SECURITIES = 'security-report',
  FINANCE_RECON = 'recon',
  FINANCE_RECON_METRICS = 'metrics',
  FINANCE_RECON_ROUNDS = 'round',
  FINANCE_DETAILS = 'details',
  FINANCE_TRANSACTION_HISTORY = 'history',
  FINANCE_TRANSACTIONS_3 = 'transactions3',
  FINANCE_ROUNDS = 'rounds',
  FINANCE_LEDGER = 'ledger',
  FINANCE_HISTORY = 'finance/:companyId',
  FUND_PROFILES = 'fund-profiles',
  GENERAL_LEDGER = 'general-ledger',
  BULK_DEAL_DOCS = 'bulk-deal-docs',
  UPDATE_DEAL_DOCS_ROUND = 'update-deal-docs-round',
  RESET_REINGESTION = 'reset-reingestion',
  FP_CAPITAL_ALLOCATION = 'fp-capital-allocation',
  FP_RESERVES = 'fp-reserves',
  FP_SUMMARY = 'fp-summary',
  FP_WATERFALL = 'fp-waterfall',
  INTEGRATIONS = 'integrations',
  INTEGRATIONS_APPS = 'apps',
  INTEGRATIONS_APPS_AFFINITY = 'affinity',
  INTEGRATIONS_APPS_AIRTABLE = 'airtable',
  INTEGRATIONS_APPS_ALLVUE = 'allvue',
  INTEGRATIONS_APPS_ARKPES = 'arkpes',
  INTEGRATIONS_APPS_CARTA = 'carta',
  CARTA_FIRMS = 'firms',
  CARTA_HOLDERS = 'holders',
  CARTA_RUNS = 'runs',
  INTEGRATIONS_APPS_ILEVEL = 'ilevel',
  INTEGRATIONS_APPS_QUICKBOOKS = 'quickbooks',
  INTEGRATIONS_APPS_STANDARD_METRICS = 'standard-metrics',
  INTEGRATIONS_APPS_COBALT = 'cobalt',
  PORTFOLIO = 'portfolio',
  DOCS = 'docs',
  KPI_DISPLAY = 'kpi-display',
  KPI = 'kpis',
  KPI_MANAGE = 'manage',
  KPI_REQUESTS = 'requests',
  KPI_REQUESTS_RESPONSES_HOME = 'kpis/response',
  KPI_PENDING_REQUESTS_BASE = 'kpis/pending-requests',
  KPI_PENDING_REQUESTS = 'kpis/pending-requests/:companyId',
  KPI_THANK_YOU_SCREEN = 'kpis/thank-you',
  KPI_REQUEST_REVIEW = 'kpis/response/:requestId',
  KPI_REQUESTS_IN_PROGRESS = 'in-progress',
  KPI_REQUESTS_ARCHIVED = 'archived',
  KPI_RESPONSES = 'responses',
  KPI_RESPONSES_ACCEPTED = 'accepted',
  KPI_RESPONSES_MS_PENDING = 'ms-pending',
  KPI_RESPONSES_MS_IN_PROGRESS = 'ms-in-progress',
  KPI_RESPONSES_MS_REVIEWED = 'ms-reviewed',
  KPI_RESPONSES_REJECTED = 'rejected',
  KPI_RESPONSES_ANALYSIS = 'analysis',
  KPI_CUSTOM_TEMPLATE_CONFIGURATION = 'custom-template-configuration',
  KPI_DATA_COLLECTION_CONFIGURATION = 'dc-configuration',
  KPI_TEMPLATES = 'templates',
  KPI_TEMPLATES_FULL_ROUTE = 'kpis/templates',
  LISTS = 'lists',
  METRICS_CONFIG = 'metrics-config',
  MULTIPERIOD_REPORTING = 'multiperiod-reporting',
  SETTINGS = 'settings',
  SOURCING = 'sourcing',
  SOURCING_PROFILE = 'profile',
  TEAR_SHEETS = 'tear-sheets',
  TEAR_SHEETS_V1 = 'tearsheet-v1',
  TEAR_SHEETS_V2 = 'tearsheet-v2',
  TEAR_SHEETS_HEADER_CONFIG = 'header',
  TEAR_SHEETS_CAPITALIZATION_SUMMARY_CONFIG = 'capitalization-summary',
  TEAR_SHEETS_COMPANY_DESCRIPTION_CONFIG = 'company-description',
  TEAR_SHEETS_COMPANY_SUMMARY_CONFIG = 'company-summary',
  TEAR_SHEETS_FINANCING_HISTORY_CONFIG = 'financing-history',
  TEAR_SHEETS_INVESTMENT_SUMMARY_CONFIG = 'investment-summary',
  TEAR_SHEETS_INVESTMENT_THESIS_CONFIG = 'investment-thesis',
  TEAR_SHEETS_PERFORMANCE_COMMENTARY_CONFIG = 'performance-commentary',
  TEAR_SHEETS_PERFORMANCE_SUMMARY_CONFIG = 'performance-summary',
  UPLOAD_STATUS = 'upload-status',
  PROCESSING = 'processing',
  UI = 'ui',
  ADMIN_PANEL_RECONCILIATION_MONITOR = 'reconciliation-monitor',
  ADMIN_PANEL_ATLAS_CONSOLE = 'atlas-console',
  ADMIN_PANEL_ARGUS_PROFILES = 'argus/profiles',
  ADMIN_PANEL_ARGUS_PROFILE_DETAIL = 'argus/profiles/:id',
  SAVED_SEARCHES = 'saved-searches',
  SOURCING_RESULTS = 'search-results',
}

export function getRouteTitle(route: string) {
  const roundsLabel = pluralizeWord(getRoundLabel(), 2);
  const mapping = {
    [ROUTES.ADMIN_PANEL]: 'Admin Panel',
    [ROUTES.ADMIN_PANEL_AUDITOR_CONFIG]: 'Auditor Configuration',
    [ROUTES.ADMIN_PANEL_COLUMNS]: 'Columns',
    [ROUTES.ADMIN_PANEL_DATA_COLLECTION]: 'Data Collection',
    [ROUTES.ADMIN_PANEL_DATA_DISPLAY]: 'Data Display',
    [ROUTES.ADMIN_PANEL_MAPPINGS]: 'Company Mappings',
    [ROUTES.ADMIN_PANEL_FIELD_MANAGER]: 'Field Manager',
    [ROUTES.ADMIN_PANEL_FIELDS]: 'Fields',
    [ROUTES.ADMIN_PANEL_FORMATTERS]: 'Formatters',
    [ROUTES.ADMIN_PANEL_MANAGE_ACCESS]: 'Manage Access',
    [ROUTES.ADMIN_PANEL_ORG_PROFILE]: 'Org Profile',
    [ROUTES.ADMIN_PANEL_ROUND_CREATION]: `${getRoundLabel()} Creation`,
    [ROUTES.ADMIN_PANEL_RUBRICS]: 'Rubrics',
    [ROUTES.ADMIN_PANEL_TEARSHEET_GENERATION]: 'Tearsheet Generation',
    [ROUTES.ADMIN_PANEL_TABLE_DOWNLOAD]: 'Export Data',
    [ROUTES.APPLICATION_SETTINGS]: 'Application Settings',
    [ROUTES.ASSIGNED_COMPANIES]: 'Assigned',
    [ROUTES.BULK_UPLOAD_REPORT]: 'Bulk Upload Report',
    [ROUTES.CAP_TABLE_FORM]: 'Add Cap Table',
    [ROUTES.COMPANIES]: 'Companies',
    [ROUTES.COMPANIES_OVERVIEW]: 'Companies Overview',
    [ROUTES.COMPANY_PROFILES]: 'Companies',
    [ROUTES.COMPANY_PROFILE_CAP_TABLE]: 'Cap Table',
    [ROUTES.COMPANY_PROFILE_COMPETITORS]: 'Competitors',
    [ROUTES.COMPANY_PROFILE_FINANCIALS]: 'Financials',
    [ROUTES.COMPANY_PROFILE_MAPPINGS]: 'Mappings',
    [ROUTES.COMPANY_PROFILE_NICHE_VCS]: 'Niche VCs',
    [ROUTES.COMPANY_PROFILE_PEOPLE]: 'People',
    [ROUTES.COMPANY_PROFILE_PERFORMANCE]: 'Performance',
    [ROUTES.COMPANY_PROFILE_SCENARIOS]: 'Scenario Modeling',
    [ROUTES.COMPANY_PROFILE_SCENARIO_RUN]: 'Scenario Run',
    [ROUTES.COMPANY_PROFILE_SCENARIO_WEIGHTED]: 'Weighted Outcome',
    [ROUTES.COMPANY_PROFILE_SCENARIO_SETTINGS]: 'Scenario Settings',
    [ROUTES.COMPANY_PROFILE_SINGLE_SCENARIO]: 'Scenario',
    [ROUTES.COMPANY_PROFILE_SUMMARY]: 'Summary',
    [ROUTES.CONFIG]: 'Config',
    [ROUTES.CONFIG_DEAL_STAGES]: 'Deal Stages',
    [ROUTES.CONFIG_DEAL_TYPES]: 'Deal Types',
    [ROUTES.CONFIG_FIELD_AUTOMATION]: 'Field Automation',
    [ROUTES.CONFIG_FUNDS]: 'Funds',
    [ROUTES.CONFIG_KPI]: 'KPIs',
    [ROUTES.CONFIG_KPI_GROUPS]: 'KPI Groups',
    [ROUTES.CONFIG_KPI_SOURCES]: 'KPI Sources',
    [ROUTES.CONFIG_MISS_REASONS]: 'Miss Reasons',
    [ROUTES.CONFIG_PASS_REASONS]: 'Pass Reasons',
    [ROUTES.CONFIG_SECTORS]: 'Sectors',
    [ROUTES.DEALS]: 'Deals',
    [ROUTES.DEAL_ANALYTICS]: 'Analytics',
    [ROUTES.DEAL_ANALYTICS_DURATION_DETAILS]: 'Deal Duration Details',
    [ROUTES.DEAL_ANALYTICS_KPI]: 'Deal KPIs',
    [ROUTES.DEAL_FLOW]: 'Pipeline',
    [ROUTES.DETAILS_CONFIG]: 'Edit Details Section',
    [ROUTES.ENTITIES]: 'Entity Management',
    [ROUTES.ENTITIES_STRUCTURE_CHART]: 'Structure Chart',
    [ROUTES.ENTITIES_REGISTRY]: 'Legal Entity Registry',
    [ROUTES.ENTITIES_DO_SLATE]: 'D&O Slate',
    [ROUTES.ENTITIES_BENEFICIAL_OWNERSHIP]: 'Beneficial Ownership',
    [ROUTES.ENTITIES_REVIEW_QUEUES]: 'Review Queues',
    [ROUTES.FINANCE2]: 'Finance',
    [ROUTES.FINANCE]: 'Finance',
    [ROUTES.FINANCE_ALL_SECURITIES]: 'All Securities',
    [ROUTES.FINANCE_HISTORY]: 'Finance History',
    [ROUTES.FINANCE_RECON]: 'Reconciliation',
    [ROUTES.FINANCE_RECON_METRICS]: 'Metrics',
    [ROUTES.FINANCE_RECON_ROUNDS]: roundsLabel,
    [ROUTES.FINANCE_ROUNDS]: roundsLabel,
    [ROUTES.FINANCE_LEDGER]: 'Ledger',
    [ROUTES.FINANCE_TRANSACTIONS_3]: 'Transactions',
    [ROUTES.FINANCE_TRANSACTION_HISTORY]: 'History',
    [ROUTES.FUND_PROFILES]: 'Fund Profiles',
    [ROUTES.FP_CAPITAL_ALLOCATION]: 'Capital Allocation Model',
    [ROUTES.FP_RESERVES]: 'Reserves',
    [ROUTES.FP_SUMMARY]: 'Summary',
    [ROUTES.FP_WATERFALL]: 'Waterfall',
    [ROUTES.GENERAL_LEDGER]: 'General Ledger',
    [ROUTES.BULK_DEAL_DOCS]: 'Bulk Deal Documents',
    [ROUTES.UPDATE_DEAL_DOCS_ROUND]: 'Update Round for Deal Docs',
    [ROUTES.RESET_REINGESTION]: 'Reset for Re-Ingestion',
    [ROUTES.INTEGRATIONS]: 'Integrations',
    [ROUTES.INTEGRATIONS_APPS]: 'Apps',
    [ROUTES.INTEGRATIONS_APPS_AFFINITY]: 'Affinity',
    [ROUTES.INTEGRATIONS_APPS_AIRTABLE]: 'Airtable',
    [ROUTES.INTEGRATIONS_APPS_ALLVUE]: 'AllVue',
    [ROUTES.INTEGRATIONS_APPS_ARKPES]: 'Ark PES',
    [ROUTES.INTEGRATIONS_APPS_CARTA]: 'Carta',
    [ROUTES.CARTA_FIRMS]: 'Firms',
    [ROUTES.CARTA_HOLDERS]: 'Holders',
    [ROUTES.CARTA_RUNS]: 'Runs',
    [ROUTES.INTEGRATIONS_APPS_ILEVEL]: 'iLevel',
    [ROUTES.INTEGRATIONS_APPS_QUICKBOOKS]: 'QuickBooks',
    [ROUTES.INTEGRATIONS_APPS_STANDARD_METRICS]: 'Standard Metrics',
    [ROUTES.INTEGRATIONS_APPS_COBALT]: 'Cobalt',
    dropbox: 'Dropbox',
    'google-drive': 'Google Drive',
    salesforce: 'Salesforce',
    slack: 'Slack',
    xero: 'Xero',
    [ROUTES.KPI_DISPLAY]: 'KPI Display',
    [ROUTES.KPI]: 'Data Collection',
    [ROUTES.KPI_REQUESTS]: 'Requests',
    [ROUTES.KPI_REQUESTS_ARCHIVED]: 'Deleted',
    [ROUTES.KPI_REQUESTS_IN_PROGRESS]: 'In Progress',
    [ROUTES.KPI_RESPONSES]: 'Responses',
    [ROUTES.KPI_RESPONSES_ACCEPTED]: 'Accepted',
    [ROUTES.KPI_RESPONSES_MS_PENDING]: 'MS To Review',
    [ROUTES.KPI_RESPONSES_MS_IN_PROGRESS]: 'MS In Progress',
    [ROUTES.KPI_RESPONSES_MS_REVIEWED]: 'MS Reviewed',
    [ROUTES.KPI_RESPONSES_REJECTED]: 'Rejected',
    [ROUTES.KPI_TEMPLATES]: 'Templates',
    [ROUTES.LISTS]: 'Lists',
    [ROUTES.KPI_CUSTOM_TEMPLATE_CONFIGURATION]: 'Template Configuration',
    [ROUTES.KPI_DATA_COLLECTION_CONFIGURATION]: 'Configuration',
    [ROUTES.KPI_MANAGE]: 'Manage KPI Requests',
    [ROUTES.METRICS_CONFIG]: 'Edit Investment Metrics Section',
    [ROUTES.MULTIPERIOD_REPORTING]: 'Multi-Period Reporting',
    [ROUTES.PORTFOLIO]: 'Portfolio Reporting',
    [ROUTES.DOCS]: 'Documents',
    [ROUTES.SETTINGS]: 'Settings',
    [ROUTES.SAVED_SEARCHES]: 'Saved Searches',
    [ROUTES.SOURCING]: 'Sourcing',
    [ROUTES.SOURCING_PROFILE]: 'Sourcing Profile',
    [ROUTES.UI]: 'UI Components',
    [ROUTES.UPLOAD_STATUS]: 'Upload History',
    [ROUTES.PROCESSING]: 'Processing',
    [ROUTES.TEAR_SHEETS_V2]: 'Tearsheet V2',
    [ROUTES.ADMIN_PANEL_RECONCILIATION_MONITOR]: 'Reconciliation Monitor',
    [ROUTES.ADMIN_PANEL_ATLAS_CONSOLE]: 'Atlas Console',
    [ROUTES.ADMIN_PANEL_ARGUS_PROFILES]: 'ARGUS Profiles',
  } as Record<string, string>;
  return mapping[route] ?? route;
}
